// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DmnModelerController from "./dmn_modeler_controller";
application.register("dmn-modeler", DmnModelerController);

import DmnViewerController from "./dmn_viewer_controller";
application.register("dmn-viewer", DmnViewerController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import ExpressionSandboxController from "./expression_sandbox_controller";
application.register("expression-sandbox", ExpressionSandboxController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import JsonEditorController from "./json_editor_controller";
application.register("json-editor", JsonEditorController);

import SplitScreenController from "./split_screen_controller";
application.register("split-screen", SplitScreenController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);
